// PROTOTYPE (hero v2): the page's description and structured data, built
// only from copy the page shows, so search engines and AI answers describe
// what a visitor reads. The description is the intro's heading followed by
// its first sentence. Crawlers read the prerendered page, which is the
// current hero, so this takes effect only once v2 is the default. Both are
// in the page's language, `seo.lang` (useSeoLinks).
export const HERO_V2_DESCRIPTION = {
  it: "Il potere del video al servizio della consulenza finanziaria. Realizza videomessaggi, presenta contenuti e moltiplica gli incontri con i tuoi clienti senza moltiplicare il tempo.",
  en: "The power of video, put to work for financial advice. Record video messages, present your content and multiply your client meetings without multiplying your time.",
};

const IN_LANGUAGE = { it: "it-IT", en: "en" };

// The company is the footer's; the product's systems are the intro's.
export function heroV2StructuredData(seo) {
  const company = "https://avrah.it/#company";
  return JSON.stringify({
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Organization",
        "@id": company,
        name: "Home SeTV S.r.l.",
        url: "https://avrah.it/",
        vatID: "11379820969",
        address: {
          "@type": "PostalAddress",
          streetAddress: "Via Vincenzo Monti 25",
          postalCode: "20123",
          addressLocality: "Milano",
          addressCountry: "IT",
        },
      },
      {
        "@type": "SoftwareApplication",
        name: "A.V.R.A.H.",
        alternateName: "Avrah",
        applicationCategory: "MultimediaApplication",
        operatingSystem: "macOS, Windows",
        inLanguage: IN_LANGUAGE[seo.lang],
        description: HERO_V2_DESCRIPTION[seo.lang],
        url: seo.canonical,
        publisher: { "@id": company },
      },
    ],
  });
}
